import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setupAxiosInterceptor } from "./api/axiosInterceptor";
import { getToken } from "./utils/Utils";

/**
 * AppRoot component - Wrapper that handles app-level token validation
 * and axios interceptor setup
 */
const AppRoot = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Setup axios interceptor for handling 401 errors
    setupAxiosInterceptor(navigate);
  }, [navigate]);

  useEffect(() => {
    // Check if user is on public routes (auth pages)
    const isPublicRoute = [
      "/auth-login",
      "/auth-register",
      "/auth-forgot-password",
      "/",
    ].includes(location.pathname);

    const token = getToken();

    // If no token and trying to access protected route, redirect to login
    if (!isPublicRoute && !token) {
      navigate("/auth-login", { replace: true });
    }

    // If token exists but on login page, redirect to dashboard
    if (token && location.pathname === "/auth-login") {
      navigate("/dashboard", { replace: true });
    }
  }, [location.pathname, navigate]);

  return children;
};

export default AppRoot;
